import { computed, EnvironmentProviders, Injector, Provider } from '@angular/core';
import { SOFTLINE_CONFIG_SETTINGS } from '@softline/application';
import { SettingsComponent } from './components/settings.component';
import { UserInfoService } from '@softline/auth';
import { toObservable } from '@angular/core/rxjs-interop';

export const SOFTLINE_SETTINGS_USER_CONTEXT = 'userContext';

export const contextSettingsProviders: (
  | Provider
  | EnvironmentProviders
)[] = [
  {
    provide: SOFTLINE_CONFIG_SETTINGS,
    multi: true,
    useFactory: (svc: UserInfoService, injector: Injector) => {
      return {
        key: SOFTLINE_SETTINGS_USER_CONTEXT,
        component: SettingsComponent,
        title: '#UTILITIES.SETTINGS.CONTEXT.TITLE',
        icon: 'fa-regular fa-briefcase',
        visible: toObservable(computed(() => !!svc.value()), { injector })
      };
    },
    deps: [UserInfoService, Injector]
  }
];
